import DefaultPreviewPlaceholder from './default'

export default DefaultPreviewPlaceholder
